module.exports = __webpack_public_path__ + "img/aboutUsSection.3b2b0700.png";